var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVentas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3913 4.82609C19.3913 4.2738 18.9436 3.82609 18.3913 3.82609H8.31503C5.93191 3.82609 4 5.75799 4 8.14112C4 10.3038 5.60101 12.1325 7.74474 12.4183L16.3388 13.5642C17.4889 13.7175 18.3478 14.6986 18.3478 15.8589C18.3478 17.1374 17.3114 18.1739 16.0328 18.1739H5.95652C5.40424 18.1739 4.95652 18.6216 4.95652 19.1739C4.95652 19.7262 5.40424 20.1739 5.95652 20.1739H16.0328C18.4159 20.1739 20.3478 18.242 20.3478 15.8589C20.3478 13.6962 18.7468 11.8675 16.6031 11.5817L8.00907 10.4358C6.85895 10.2825 6 9.30141 6 8.14112C6 6.86256 7.03648 5.82609 8.31503 5.82609H18.3913C18.9436 5.82609 19.3913 5.37837 19.3913 4.82609Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C11.4477 5 11 4.55228 11 4V2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2V4C13 4.55228 12.5523 5 12 5Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C11.4477 23 11 22.5523 11 22V20C11 19.4477 11.4477 19 12 19C12.5523 19 13 19.4477 13 20V22C13 22.5523 12.5523 23 12 23Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentas);
export default __webpack_public_path__ + "static/media/ventas.a245892ea9bcefab9a572742b22abb23.svg";
export { ForwardRef as ReactComponent };